<template>
<b-row class="type2-diabetes disease-pages no-gutters">
  <b-col class="tool-border" cols="12">
    <b-col class="reduce-padding" cols="12">
      <wlpHeader :pageTitle="pageTitle" :pageImage="pageImage"></wlpHeader>
    </b-col>

    <b-col class="page-background-gradient reduce-padding" cols="12">
      <b-row class="page-content  no-gutters">
        <b-row class="body-sec no-gutters">
          <b-col class="reduce-padding top-section" cols="12">
            <b-row class="no-gutters">
              <b-col class="reduce-padding text-section" lg="8" md="8" cols="12">
                <div class="top-text-title bold-text">
                   <span v-if="userData.conditions.diab">{{$t('common.top-text-title3')}}</span><span v-if="!userData.conditions.diab">{{$t('common.top-text-title')}}</span>
                </div>
                <div class="top-text bottom-spacing" v-if="!userData.conditions.diab">
                   {{$t('diabetes.top-text')}} 
                </div>
                <div v-if="userData.conditions.diab" :class="{'top-text-sp' : $i18n.locale=='sp'}" class="top-text overweight-txt top-text-checked" >
                   {{$t('diabetes.top-text2')}} 
                </div>
              </b-col>
              <b-col class="reduce-padding check-section" lg="4" md ="4" cols="12">
                <b-row class="check-yes-section no-gutters">
                  <div class="condition-checkboxes wlp-checkboxes">
                    <input @change="toggleAdjButtons()" type="checkbox" name="diabCondition" v-model="userData.conditions.diab" id="diabCondition" value="diabCondition">
                    <label class="" for="diabCondition">
                      <div class="condition-label">{{$t('diabetes.condition-label-1')}} <br> {{$t('diabetes.condition-label-2')}} <br> {{$t('diabetes.condition-label-3')}} </div>
                  </label>
                  </div>
                </b-row>
              </b-col>
            </b-row>
            <div class="top-hr" :class="{'top-hr-sp' : $i18n.locale=='sp'}"></div>
          </b-col>

          <b-col class="reduce-padding graph-col" lg="8" md="7" cols="12">
            <b-col class="reduce-padding" v-if="userData.conditions.diab" cols="12">
              <div class="">
                <b-row class="no-gutters top-feild-space fields-cover">
                  <div class="reduce-padding">
                    <div class="fields-head"> {{$t('diabetes.inputField')}} <span class="unbold"> (5.0-14.0%):</span></div>
                  </div>
                  <div class=" bp-div reduce-padding">
                    <div class="diab-field " :class="{'haserror': ( submitted &&  (!$v.userData.diab.required  ||  !$v.userData.diab.maxLength || !$v.userData.diab.between) ) }">
                      <input class="common-feilds diab" name="diab" type="text" v-model="diab" maxLength="6" placeholder="%" @change="getMaskedVal(diab);a1cBars();"  :class="{'greytxt': this.$v.userData.diab.$invalid   }">
                    </div>
                  </div>
                </b-row>
                <b-row class="hyperlipidemia-graph-title bold-text no-gutters">
                  <div class="validation-div" :class="{'validation-div-sp' : $i18n.locale=='sp'}">
                    <div class="validation-txt" v-if="((submitted &&  (!$v.userData.diab.required || 
                      !$v.userData.diab.maxLength  || !$v.userData.diab.between ) ) || (submitted &&  (parseFloat(userData.diab) < 5  ||  parseFloat(userData.diab) > 14)  ) )">{{$t('error.error-required')}}</div>
                  </div>
                </b-row>
              </div>
            </b-col>

            <div v-if="!userData.conditions.diab">
              <div class="graph-title graph-title-space graph-title-common bold-text">
                {{$t('diabetes.linegraphTitle')}}
              </div>
              <div class="graph-sub-title below-space graph-title-common ">
                <span v-if="userData.adjustButtons.diab>0">{{userData.adjustButtons.diab}}% {{$t('graph.lowerWeight')}} </span>
                (%)
              </div>
            </div>
            <div v-if="userData.conditions.diab">
              <div class="graph-title a1c-text graph-title-common graph-title-common-isch bold-text">
                 {{$t('diabetes.bargraphTitle')}}
              </div>
              <div class="graph-sub-title sub-text-space graph-title-common">
                <span v-if="userData.adjustButtons.diab>0">{{userData.adjustButtons.diab}}% {{$t('graph.lowerWeight')}} </span>
                (%)
              </div>
            </div>
            
            <!--GRAPHS-->
            <div class="graphs-div">
              <div class="bar-graph-div" v-if="userData.conditions.diab">
                <barGraph :disease="'diab'" :barValues="userData.calc.diabA1c" :adjustSelection="userData.adjustButtons.diab" 
                :displayBars="(parseFloat(userData.diab) > 4  && parseFloat(userData.diab) < 15)" :lblEndX="14" :lblStartX="4" :lblSkipX="1"></barGraph>
              </div>
              <div v-if="!userData.conditions.diab">
                <lineChart :disease="'diab'" :risk="userData.calc.diab" :adjustSelection="userData.adjustButtons.diab" :lblEndX="50" :lblStartY="-10" :lblEndY="50" :lblSkipY="10"
                :confInt="this.userData.confInt.diab"></lineChart>
              </div>
            </div>
            
            <!--GRAPH BOTTOM-->
            <b-col class="graph-bottom type2-graph-bottom" cols="12" v-if="!userData.conditions.diab">
              <b-row class="no-gutters">
                <b-col class="reduce-padding legends order-lg-1 order-2" lg="4" cols="12">
                  <b-row class=" no-gutters">
                    <b-col class="reduce-padding risk-bullets" lg="6" md="4" cols="12">
                      <div class="bullet blue"></div>
                      <div class="bullet-text" :class="{'bullet-text-sp' : $i18n.locale=='sp'}">{{$t('common.currentRisk')}}</div>
                    </b-col>
                    <b-col class="reduce-padding risk-bullets" lg="6" md="6" cols="12">
                      <div class="bullet green" v-if="userData.adjustButtons.diab>0" md="6" ></div>
                      <div class="bullet-text" :class="{'bullet-text-sp' : $i18n.locale=='sp'}" v-if="userData.adjustButtons.diab>0"  md="6" >{{$t('common.adjustedRisk')}}</div>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col class="reduce-padding x-label-title order-lg-2 order-1" lg="2" cols="12">
                  <div class="">{{$t('common.bmi')}}</div>
                </b-col>
              </b-row>
            </b-col>
        
            <b-col class=" graph-bottom type2-bar-graph bar-graph-bottom condition-bottom" v-if="userData.conditions.diab">
              <b-row class="no-gutters">
                
                  <div class="bottom-section-type2" :class="{'bottom-section-type2-sp' : $i18n.locale=='sp'}" v-show="(parseFloat(userData.diab) >= 5  &&  parseFloat(userData.diab) <= 14) ">
                      <div class ="weight-loss-txt before-loss">
                        <div class="bullet blue"></div>
                        <div class="bullet-text" :class="{'bullet-text-sp' : $i18n.locale=='sp'}">{{$t('common.beforeWeight')}}</div>
                      </div>
                      <div class ="weight-loss-txt after-loss">
                        <div class="bullet green" v-if="userData.adjustButtons.diab>0"></div>
                        <div class="bullet-text" :class="{'bullet-text-sp' : $i18n.locale=='sp'}" v-if="userData.adjustButtons.diab>0">{{$t('common.afterWeight')}}</div>
                      </div>  
                  </div>
              </b-row>
            </b-col>
          
          </b-col>
          <b-col class="reduce-padding adj-weight-col" md="4" cols="12">
            <b-row class="no-gutters">
              <b-col class="triangle-outer reduce-padding" cols="12">
                  <div class = "triangle-img"></div>
              </b-col>
              <b-col class="diabetes-page reduce-padding">
                <weightAdjustmentBox :disease="diseaseName" :condition="userData.conditions.diab" :adjButtons="adjButtonsArray" :adjustSelection="userData.adjustButtons.diab" 
                :btnClickHandler="btnClickHandler()" @adjustPercUpdate="userData.adjustButtons.diab=$event"></weightAdjustmentBox>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-row>

      <wlpNavigation :navButtons="['info','references','tnc','menu','back','next']" :currentScreen="8" :btnClickHandler="this.handleSubmit"></wlpNavigation>
    </b-col>
  </b-col>
</b-row>
</template>
<script>
  /* eslint-disable */
  import scrollMixin from "../mixins/scrollMixin";
  import wlpHeader from '../components/wlpHeader.vue';
  import wlpNavigation from '../components/wlpNavigation.vue';
  import lineChart from '../components/lineChart.vue';
  import barGraph from '../components/barGraph.vue';
  import weightAdjustmentBox from '../components/weightAdjustmentBox.vue';
  import { mapGetters, mapMutations } from 'vuex';
  import { required, maxLength, decimal, minLength, between } from "vuelidate/lib/validators";

  export default {
    name: "type2Diabetes",
    mixins: [scrollMixin],
    created() {
  
    },
    mounted: function() {
  
      this.scrollToTop();
      // this.toggleAdjButtons();
      this.adjButtonsArray = this.userData.conditions.diab ? ['five', 'ten'] : ['five', 'ten', 'fifteen', 'twenty'];
      this.a1cBars();
       if(this.userData.diab !== '') {
        
      this.getMaskedVal(String(this.userData.diab));
      }
       this.markSectionComplete({section:'diab'});
    },
    components: {
      'wlpHeader': wlpHeader,
      'wlpNavigation': wlpNavigation,
      'lineChart': lineChart,
      'weightAdjustmentBox': weightAdjustmentBox,
      'barGraph': barGraph,
    },

    validations: {
      userData: {
        diab: {
          required,
          minLength: minLength(1),
          maxLength: maxLength(5),
          between: between(5.0, 14.0)
        }
      }

    },

    data() {
      return {
        pageTitle: this.$t('common.diabetes'),
        diseaseName: this.$t('common.diabetes').toLowerCase(),
        pageImage: 'type2Diabetes-img',
        submitted: false,
        adjButtonsArray: ['five', 'ten', 'fifteen', 'twenty'],
        diab: ''
      };
    },

    computed: {
      ...mapGetters('userData', ['userData']),
    },

    methods: {
      ...mapMutations('userData', ['saveCalculations', 'markSectionComplete']),
      
     
      a1cBars: function() {
        if ((parseFloat(this.userData.diab) > 4  && parseFloat(this.userData.diab) < 15)) {
        // this.getMaskedVal(this.diab);
        this.saveCalculations({
          data: {
            current: [parseFloat(this.userData.diab)],
            adj5: [this.userData.diab-this.getDiabVal(5)],
            adj10: [this.userData.diab-this.getDiabVal(10)],
          },
          section: 'diabA1c'
        });
        }
        console.log("diabA1c: " + JSON.stringify(this.userData.calc.diabA1c));
      },

      toggleAdjButtons: function() {
        this.userData.adjustButtons.diab = this.userData.conditions.diab? 0: this.userData.adjustButtons.diab;
        this.adjButtonsArray = this.userData.conditions.diab ? ['five', 'ten'] : ['five', 'ten', 'fifteen', 'twenty'];
      },
      
      getDiabVal: function(d) {
        var calc = -0.000224 + (d / 100) * 0.1010204;
        calc= Math.round(calc*1000)/10;
        return calc;
      },

      getMaskedVal: function(newvalue) {
              console.log("newvalue ", newvalue)

        var value;
        var nn;
        var dd;
        if(newvalue !== '' ) {
           nn = newvalue.split("%");
                console.log("nn ", nn)
        dd = parseFloat(nn[0]);

        value = Number(dd);
        }
        else {
          value = ''
          this.diab = value;
           this.userData.diab = value;
          return;
        }

        if (value > 0 && value % 1 == 0) {
          this.diab = value + '.' + '0%';
        }
        else {
          this.diab = value + '%';
        }
        // console.log("this.diab ", this.diab)
        let d = this.diab.split("%");
                console.log("d ", d)
        this.userData.diab = parseFloat(d[0]);
        // console.log("this.userDatadiab ", this.userData.diab)
      },


      handleSubmit() {
        this.submitted = true;
        this.$v.$touch();
        if ((this.userData.conditions.diab && this.$v.$invalid)) {
          this.scrollToError();
          return false;
        }
        
        return true;
      },
      btnClickHandler: function() {
        if (this.userData.adjustButtons.diab &&((this.userData.conditions.diab && this.$v.$invalid))) {
          this.submitted = true;
           this.scrollToError();
        }
      },
    }
  };
</script>


<style lang="scss" scoped>
</style>
